import { ERentTime, getTermValue } from '@/packages/JsonQuery';

import { type ITagGroupConfig } from '../types';

const TEXT_MAP: { [key in ERentTime]: string | null } = {
  [ERentTime.FromYear]: 'Аренда от года',
  [ERentTime.FewMonths]: 'От нескольких месяцев',
  [ERentTime.Daily]: null,
  [ERentTime.NotDaily]: null,
  [ERentTime.AnyTerm]: null,
};

export const rentTime: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getTermValue('for_day')(jsonQuery);
    if (!value) {
      return null;
    }

    const text = TEXT_MAP[value];
    if (!text) {
      return null;
    }

    return [
      {
        group: 'rentTime',
        text,
      },
    ];
  },
  delete({ onChange }) {
    onChange({
      action: 'setRentalPeriod',
      arguments: [ERentTime.NotDaily],
    });
  },
};
